const SHORT_NAMES = {
  "Black Market 347": "347",
  "Black Market 256": "256",
  "Public Butter Kensington": "PB",
  "Dirty Mike's": "Dirty Mike's",
};

export function storeName(name) {
  if (!name) return name;
  return SHORT_NAMES[name] || name;
}
